import { useRef, useCallback } from 'preact/hooks';

export function useSingleClick(callback, delay = 200) {
    const lastClickTime = useRef(0);

    return useCallback((e) => {
        const now = Date.now();
        if (now - lastClickTime.current < delay) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        lastClickTime.current = now;
        callback(e);
    }, [callback, delay]);
}